<script setup lang="ts">
type Props = {
  filterOptions: any[];
};
defineProps<Props>();

defineEmits(['select-filter']);
</script>

<template>
  <div
    ref="filterOptionsRef"
    :class="$style.filterOverlay"
  >
    <ul :class="$style.filterList">
      <li
        v-for="(option, index) in filterOptions"
        :key="`${option.value}-${index}`"
        :class="$style.filterListItem"
        @click="$emit('select-filter', option)"
      >
        <NuxtIcon
          :class="$style.filterIcon"
          :name="option.icon"
        />
        {{ option.label }}
      </li>
    </ul>
  </div>
</template>

<style module lang="scss">
.filterOverlay {
  @apply absolute w-full z-10 right-0 top-full mt-1 bg-bg-secondary text-texts rounded-md opacity-100 min-w-24 overflow-hidden;

  &::before {
    @apply content-[''] absolute left-0 top-0 w-full h-full bg-texts/5 -z-10;
  }

  .filterList {
    @apply list-none p-0 m-0;

    .filterListItem {
      @apply py-2 px-2 lg:px-4 text-xs cursor-pointer border-solid border-b border-texts/15 first:rounded-t-md last:rounded-b-md last:border-transparent hover:bg-primary/10 hover:text-primary flex items-center justify-center gap-1.5;

      .filterIcon {
        @apply text-2xs text-texts/60;
      }

      &:hover {
        .filterIcon {
          @apply text-primary/80;
        }
      }
    }
  }
}
</style>
